// extracted by mini-css-extract-plugin
module.exports = {"section":"homeAnimations_section__OU0Dv","visible":"homeAnimations_visible__dIzmg"};